import { Component, OnInit } from '@angular/core';
import { AppService } from '../../services/app.service';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  isCollapsed = true;

  constructor(private appService: AppService,
    private router: Router) { }

  ngOnInit(): void {
  }

  toggleSidebarPin() {
    this.appService.toggleSidebarPin();
  }
  toggleSidebar() {
    this.appService.toggleSidebar();
  }

  signOff(){
    Swal.fire({
      title: 'Alerta',
      text: "¿Quieres cerrar sesion?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('avatar')
        localStorage.removeItem('userName')
        localStorage.removeItem("token");
        localStorage.removeItem('info-mtn')
        localStorage.removeItem('info-pdg-table')
        localStorage.removeItem('info-pdg-table-detail')
        localStorage.removeItem('title')
        window.location.reload()
      }
    })
  }

}
